import { futureValueLumpsum } from "../../engine/calculations";
import { currencyAxis, yearsAxis } from "./reckonerAxes";

const config = {
  key: "rr-lumpsum",
  title: "Lumpsum Investment Ready Reckoner",
  category: "Ready Reckoners",
  description: "See the future value of a one-time investment across a range of amounts and durations.",
  reckoner: true,
  rowAxis: currencyAxis("Investment Amount", [1_00_000, 2_00_000, 5_00_000, 10_00_000, 20_00_000]),
  colAxis: yearsAxis("Years", [5, 10, 15, 20, 25, 30]),
  extraFields: [
    { key: "returnRate", label: "Expected annual return", type: "percent", default: 12, min: 1, max: 30, assumptionKey: "equityReturn" },
  ],
  computeCell(amount, years, extra) {
    const annualRate = (Number(extra.returnRate) || 0) / 100;
    return futureValueLumpsum(amount, annualRate, years);
  },
};

export default config;
